import { useMutation } from "@tanstack/react-query";
import {
	CreateResourceDto,
	GetResourceResponseDto,
	restRepository,
	UpdateResourceDto,
} from "@onair/repositories";

export const useCreateResourceMutation = (options = {}) => {
	return useMutation({
		...options,
		mutationFn: async (data: CreateResourceDto) =>
			restRepository.api.resourceCreate(data),
	});
};

export const useUpdateResourceMutation = (options = {}) => {
	return useMutation({
		...options,
		mutationFn: async ({ id, data }: { id: string; data: UpdateResourceDto }) =>
			restRepository.api.resourceUpdateById(id, data),
	});
};

export const useDeleteResourceMutation = (options = {}) => {
	return useMutation({
		...options,
		mutationFn: async (id: string) => restRepository.api.resourceDeleteById(id),
	});
};

export const useResourceSearchLinkListMutation = (options = {}) => {
	return useMutation({
		...options,
		mutationFn: async (keyword: string) => {
			if (keyword) {
				const response = await restRepository.api.resourceSearchLinkList({
					keyword,
				});
				return response.data as GetResourceResponseDto[];
			}
		},
	});
};
